import axios from 'axios';

export const DISMISS_ALERT = 'DISMISS_ALERT';
export const LOAD_THEMES = 'LOAD_THEMES';
export const SELECT_THEME = 'SELECT_THEME';
export const ADD_CLAIMED_ITEM = 'ADD_CLAIMED_ITEM';
export const REMOVE_CLAIMED_ITEM = 'REMOVE_CLAIMED_ITEM';
export const UPDATE_CLAIMED_ITEMS = 'UPDATE_CLAIMED_ITEMS';
export const EMPTY_CLAIMED_ITEMS = 'EMPTY_CLAIMED_ITEMS';
export const PROFILE_LOAD = 'PROFILE_LOAD';

export const dismiss = alert => {
    return {
        type: DISMISS_ALERT,
        alert,
    };
};

export const reloadProfile = () => async (dispatch) => {
    const config = {
        url: '/profile',
        errorMessage: 'Something went wrong while loading Profile',
    };
    const result = await axios.request(config);
    dispatch({
        type: PROFILE_LOAD,
        profile: result.data
    });
};

export const getEmbeddedPageStatus = (callback) => {
    const config = {
        url: '/embeddeds/status',
    };
    axios.request(config).then(result => callback(result.data));
};



// WEBPACK FOOTER //
// ./src/containers/template/AppTemplateActions.js